import type { ColorMode } from '@hypercodestudio/basler-components/dist/models/ColorMode';
import type { ColorMode as HeroOverViewColorMode } from '@hypercodestudio/basler-components/dist/components/content-modules/sections/HeroOverviewSection.vue';
import type { ColorMode as BreadCrumbColorMode } from '@hypercodestudio/basler-components/dist/components/modules/Breadcrumb.vue';
import type { ColorMode as HeroArticleColorMode } from '@hypercodestudio/basler-components/dist/components/content-modules/sections/HeroArticleSection.vue';
import { INJECTED_COLOR_MODE } from '~/lib/constants';

export function useInjectedColorMode(): Readonly<Ref<ColorMode>> {
  return inject(INJECTED_COLOR_MODE) ?? readonly(ref('light'));
}

export type DeprecatedColorMode =
  | HeroArticleColorMode
  | HeroOverViewColorMode
  | BreadCrumbColorMode;
export function toDeprecatedColorMode(
  colorMode: Readonly<Ref<ColorMode>>
): Readonly<Ref<DeprecatedColorMode>> {
  if (colorMode.value === 'dark-purple') {
    return readonly(ref('dark'));
  }
  return colorMode as Readonly<Ref<DeprecatedColorMode>>;
}
